<template>
    <jet-form-section>
        <template #title>{{ $t("profile.timezone.title") }}</template>

        <template #description>{{
            $t("profile.timezone.description")
        }}</template>

        <template #form>
            <div class="col-span-6 sm:col-span-4">
                <jet-label
                    for="timezone"
                    :value="$t('profile.timezone.title')"
                />

                <select
                    v-model="timezone"
                    name="timezone"
                    class="mt-1 block w-full rounded-md border-iron-300 shadow-sm focus:border-z-orange-500 focus:ring-z-orange-500 sm:text-sm"
                >
                    <option v-for="tz in timezones" :key="tz" :value="tz">
                        {{ tz }}
                    </option>
                </select>
            </div>
        </template>

        <template #actions>
            <jet-button
                :class="{ 'opacity-25': loading }"
                @click.prevent="updateTimezone"
                >{{ $t("save") }}</jet-button
            >
        </template>
    </jet-form-section>
</template>

<script setup lang="ts">
import JetButton from "../../Jetstream/Button.vue";
// @ts-expect-error
import JetFormSection from "../../Jetstream/FormSection.vue";
// @ts-expect-error
import JetLabel from "../../Jetstream/Label.vue";
import { onMounted, ref } from "vue";
import route from "ziggy-js";
import { router } from "@inertiajs/vue3";
import axios from "axios";

const props = defineProps({
    user: {
        required: true,
    },
});

//@ts-expect-error
const timezone = ref<string | null>(props.user.timezone);
const timezones = ref([]);
const loading = ref(false);

const updateTimezone = function () {
    loading.value = true;

    router.put(
        route("user.update-timezone"),
        {
            timezone: timezone.value,
        },
        {
            preserveScroll: true,
            onFinish: () => {
                loading.value = false;
            },
        },
    );
};

onMounted(async function () {
    const response = await axios.get(route("api.timezones.index"));
    timezones.value = response.data.data;
});
</script>
